// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool } from 'prop-types'

const SendCorrespondence = ({ sendCorrespondence }) => (
  <i className={`fa ${sendCorrespondence ? 'fa-check-square-o' : 'fa-square-o'}`} />
)

SendCorrespondence.propTypes = {
  sendCorrespondence: bool.isRequired,
}
export default SendCorrespondence
